export default [
    {
      name: 'profile',
      title: 'profile.profile',
      icon: 'person'
    },
    {
       name: 'serverinfo',
      title: 'serverinfo.title',
      icon: 'info'
    },
    {
       name: 'activate',
      title: 'activate.title',
      icon: 'vpn_key'
    },
    {
      name: 'language',
      title: 'localesettings.language',
      icon:'language',
    },
    
]
